import { useState, useCallback } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Agent.css";
import TopHeader from "../Common/TopHeader";
import { PostApiMethod, PutApiMethod } from "../../core/services/apiService";
import constant from "../../core/constant";
import { restrictIntialSpace, ActivateDeactivate, Checkeligibility, DisplayToaster, DisplayErrorMessages } from "../../core/services/sharedService";
import AppModal from "../AppModal/AppModal";

const CreateAgent = () => {
    let navigate = useNavigate();

    const locations = useLocation();

    const getAllLocationIds = locations?.state?.agentMappedLocationDetails?.map(({ id }: { id: string }) => (
        id
    ));

    Checkeligibility(constant.AGENT_EDIT, locations, constant.AGENT_LIST);

    const { register, handleSubmit, formState: { errors } } = useForm<any>();

    const [disable, setDisable] = useState(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [showPopUp, setShowPopUp] = useState(false);
    // const [assignAllLocs, setAssignAllLocs] = useState<boolean>(locations.state.assignAllLocs);
    const [checkedLocs, setCheckedLocs] = useState<string[]>(locations?.state?.assignAllLocs ? getAllLocationIds : locations?.state?.mappedLocations);

    const agenturl = "tenant/agent-crud";
    const buttonname: string = locations.state !== null ? "Update" : "Submit";
    const headername: string =
        locations.state !== null
            ? "Edit Agent - " + locations.state?.names
            : "Create Agent";

    const pageDisable = () => {
        setDisable(true);
        setLoading(true);
        document.body.classList.add('screen-disable');
    }

    const pageEnable = () => {
        setDisable(false);
        setLoading(false);
        document.body.classList.remove('screen-disable');
    }

    const handleRegistration = (data: {
        name: string,
        email: string,
        display_name: string,
        assignAllLocs: boolean,
        mappedLocations: string[]
    }) => {
        let postDate = { name: data.name?.trim(), email: data.email?.trim(), display_name: data.display_name?.trim(), assignAllLocs: getAllLocationIds?.length === checkedLocs?.length, mappedLocations: (getAllLocationIds?.length === checkedLocs?.length) ? [] : checkedLocs };
        pageDisable();
        (locations.pathname === "/agent/create" ? PostApiMethod(agenturl, postDate) : PutApiMethod(`${agenturl}/${locations.state.id}`, postDate))
            .then((res) => {
                if (res.data.status === "Success") {
                    pageEnable();
                    navigate(constant.AGENT_LIST);
                    DisplayToaster("bg-success", "Agent " + data.name + " details " + (locations.pathname === "/agent/create" ? "created" : "updated") + " successfully");
                }
            })
            .catch((err) => {
                pageEnable();
                DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
            });
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked === true) {
            setCheckedLocs((prev) => { return [...prev, event.target.name] });
        } else {
            setCheckedLocs((prev) => (prev.filter((item: string) => {
                return item !== event.target.name
            })));
        }
    }
    return (
        <>

            {
                showPopUp &&
                (
                    <AppModal
                        title={`Confirm To ${locations.state.is_active ? "Deactivate" : "Activate"}!`}
                        bodyText={
                            `Are you sure to ${locations.state.is_active ? "deactivate" : "activate"} this Agent ?`
                        }
                        primaryButtonLabel={"Yes"}
                        secondaryButtonLabel={"No"}
                        primaryButtonEventEmitter={() => { ActivateDeactivate("Agent", locations.state?.names, "tenant/agent-crud", locations.state.id, locations.state.is_active, () => { navigate(constant.AGENT_LIST) }); setShowPopUp(false) }
                        }
                        secondaryButtonEventEmitter={() => setShowPopUp(false)}
                    />
                )
            }

            <div className="conatiner-fluid m-3">
                <TopHeader
                    disable={disable}
                    heading={headername}
                    to={constant.AGENT_LIST}
                    action="List"
                    className="bi bi-list-ul"
                    id="agent-list"
                />

                <Form onSubmit={handleSubmit(handleRegistration)}>
                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Name <span className="text-danger">*</span>
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="text"
                                defaultValue={locations.state?.names}
                                className="form-control"
                                {...register('name', {
                                    required: true, minLength: 4, maxLength: 40,
                                    // onChange: (e) => { agentNameCheck(e, 'name') },
                                    pattern: {
                                        value: /^[a-zA-Z-0-9-_ ]*$/,
                                        message: 'Name field should contain only alphabets and numbers',
                                    },
                                })}
                                onKeyDown={(e) => { restrictIntialSpace(e) }}
                            />
                            {errors.name && errors.name.type === "required" && <small className='text-danger' >Name is required</small>}
                            {errors.name && errors.name.type === "minLength" && <small className='text-danger' >Minimum length should be 4 characters</small>}
                            {errors.name && errors.name.type === "maxLength" && <small className='text-danger' >Maximum length should not exceed 40 characters</small>}
                            {errors.name && errors.name.type === "pattern" && <small className='text-danger' >Name should contain only alphabets and numbers</small>}
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Email <span className="text-danger">*</span>
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="text"
                                defaultValue={locations.state?.emails.trim()}
                                className="form-control"
                                onKeyDown={(e) => { restrictIntialSpace(e) }}
                                {...register('email',
                                    {
                                        required: true,
                                        pattern: {
                                            value: /^\w+([\+\.-]?\w+)*@\w+([\+\.-]?\w+)*(\.\w{2,3})+$/,
                                            message: 'Please enter a valid email',
                                        },
                                        setValueAs: (v) => v.trim()
                                    }
                                )}
                            />
                            {errors.email && errors.email.type === "required" && <small className='text-danger' >Email is required</small>}
                            {errors.email && errors.email.type === "pattern" && <small className='text-danger' >Please enter a valid email</small>}
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Display Name <span className="text-danger">*</span>
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="text"
                                defaultValue={locations.state?.display_names}
                                className="form-control"
                                onKeyDown={(e) => { restrictIntialSpace(e) }}
                                {...register('display_name', {
                                    required: true, minLength: 4, maxLength: 40, pattern: {
                                        value: /^[a-zA-Z-0-9-_ ]*$/,
                                        message: 'Display Name field should contain only alphabets and numbers',
                                    },
                                })}
                            />
                            {errors.display_name && errors.display_name.type === "required" && <small className='text-danger' >Display Name is required</small>}
                            {errors.display_name && errors.display_name.type === "minLength" && <small className='text-danger' >Minimum length should be 4 characters</small>}
                            {errors.display_name && errors.display_name.type === "maxLength" && <small className='text-danger' >Maximum length should not exceed 40 characters</small>}
                            {errors.display_name && errors.display_name.type === "pattern" && <small className='text-danger' >Display Name should contain only alphabets and numbers</small>}
                        </div>
                    </div>
                    {
                        locations?.state ?
                            <div className="row mb-2">
                                <div className="col-md-4">
                                    <label>
                                        Status
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="text"
                                        value={locations.state.is_active ? "Active" : "Inactive"}
                                        disabled
                                        className="form-control"
                                    />
                                </div>
                            </div> : ""
                    }

                    {
                        (locations?.state) ?
                            <div className="row mb-2 mt-3">
                                <div className="col-md-4">
                                    <label>
                                        Locations
                                    </label>
                                </div>

                                <div className="col-md-4">
                                    <fieldset className="border rounded-3 p-3">
                                        <small className="pl-3" style={{ color: '#d6327f' }}><b>Select the locations this Agent may receive and make calls</b></small>
                                        <div className="row col-8 pt-2">
                                            <div className="col-10">
                                                <b><label>Location Name</label></b>
                                            </div>
                                            <div className="col-2">
                                                <b><label>Assign</label></b>
                                            </div>
                                        </div>
                                        {
                                            locations?.state?.agentMappedLocationDetails?.map((item: { name: string, id: string }) => (

                                                <ul className="list-group list-group-flush mt-1" key={item.id}>
                                                    <li className="list-group-item">
                                                        <div className="row ">
                                                            <div className="col-7">
                                                                {item.name}
                                                            </div>
                                                            <div className="form-check col-5">
                                                                <input type="checkbox" className="form-check-input" disabled={locations.state.primaryLocations.includes(item.name.trim())}
                                                                    name={item.id}
                                                                    checked={locations.state.primaryLocations.includes(item.name.trim()) || checkedLocs.includes(item.id)}
                                                                    // defaultChecked={locations.state.primaryLocations.includes(item.name.trim()) || checkedLocs.includes(item.id) || assignAllLocs}
                                                                    onChange={handleChange} />
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>

                                            ))
                                        }
                                        <div className="text-center">
                                            <button className="btn btn-primary app-button-color btn-sm mr-1" onClick={(e: React.MouseEvent<HTMLElement>) => {
                                                e.preventDefault(); /*setAssignAllLocs(true)*/ setCheckedLocs(getAllLocationIds)
                                            }}>Select All</button>
                                            <button className="btn btn-secondary btn-sm" onClick={(e: React.MouseEvent<HTMLElement>) => { e.preventDefault(); setCheckedLocs([]) }}>Deselect All</button>
                                        </div>

                                    </fieldset>
                                </div>
                            </div> : ""

                    }

                    <div className="text-center">
                        <button
                            type="submit"
                            className="btn btn-primary app-button-color mr-2"
                            disabled={disable}
                        >
                            {isLoading && (
                                <span className="spinner-border text-white mr-1" style={{ width: '18px', height: "18px" }} role="status"></span>
                            )}{" "}
                            {buttonname}
                        </button>
                        {
                            // locations.state && <button type="button" className={locations.state.is_active ? "btn btn-danger mr-2" : "btn btn-success mr-2"} onClick={(e) => { handleDelete(e, locations.state.id, locations.state?.names) }}> {locations.state.is_active ? "Deactivate" : "Activate"} </button>
                            locations.state && <button type="button" className={locations.state.is_active ? "btn btn-danger mr-2" : "btn btn-success mr-2"} onClick={(e) => { setShowPopUp(true) }}> {locations.state.is_active ? "Deactivate" : "Activate"} </button>
                        }
                        {disable ? (
                            <Link
                                to={constant.AGENT_LIST}
                                className="disabledCursor"
                                onClick={(event) => event.preventDefault()}
                            >
                                <button
                                    type="button"
                                    disabled={disable}
                                    className="btn btn-secondary"
                                >
                                    Cancel
                                </button>
                            </Link>
                        ) : (
                            <Link to={constant.AGENT_LIST}>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                >
                                    Cancel
                                </button>
                            </Link>
                        )}
                    </div>
                </Form >
            </div >
        </>
    );
};

export default CreateAgent;
